/* eslint-disable max-len */
import React from 'react';

/* Why not just using the .svg files? Using this 
method required the execution of more JS, BUT: 
I can color these SVG's by simply setting the
text color of their parent element. Can't do
that with .svg image files.-bottom-0

The other option were to have one image for each 
color. But that would lead to overhead in other
areas and transitionig colors is not that simple. */

interface Props {
    children: React.ReactNode;
}
function SVG(props: Props) {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            className='w-full h-full'
        >
            <path d='M0 0h24v24H0V0z' fill='none' />
            {props.children}
        </svg>
    );
}

const icons = {
    download: (
        <SVG>
            <path d='M16.59 9H15V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H7.41c-.89 0-1.34 1.08-.71 1.71l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.63-.63.19-1.71-.7-1.71zM5 19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z' />
        </SVG>
    ),
    chevron_left: (
        <SVG>
            <path d='M14.71 6.71c-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z' />
        </SVG>
    ),
    chevron_right: (
        <SVG>
            <path d='M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z' />
        </SVG>
    ),
    checkbox_true: (
        <SVG>
            <path d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.29 13.29c-.39.39-1.02.39-1.41 0L5.71 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.58 7.59z' />
        </SVG>
    ),
    checkbox_false: (
        <SVG>
            <path d='M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm1-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' />
        </SVG>
    ),
    code: (
        <SVG>
            <path d='M8.7 15.9L4.8 12l3.9-3.9c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0l-4.59 4.59c-.39.39-.39 1.02 0 1.41l4.59 4.6c.39.39 1.01.39 1.4 0 .39-.39.39-1.01 0-1.4zm6.6 0l3.9-3.9-3.9-3.9c-.39-.39-.39-1.01 0-1.4.39-.39 1.01-.39 1.4 0l4.59 4.59c.39.39.39 1.02 0 1.41l-4.59 4.6c-.39.39-1.01.39-1.4 0-.39-.39-.39-1.01 0-1.4z' />
        </SVG>
    ),
    link: (
        <SVG>
            <path d='M17 7h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3 1.35 3 3s-1.35 3-3 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-9 5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1zm2 3H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h3c.55 0 1-.45 1-1s-.45-1-1-1H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h3c.55 0 1-.45 1-1s-.45-1-1-1z' />
        </SVG>
    ),
    translate: (
        <SVG>
            <path d='M12.65 15.67c.14-.36.05-.77-.23-1.05l-2.09-2.06.03-.03c1.74-1.94 2.98-4.17 3.71-6.53h1.94c.54 0 .99-.45.99-.99v-.02c0-.54-.45-.99-.99-.99H10V3c0-.55-.45-1-1-1s-1 .45-1 1v1H1.99c-.54 0-.99.45-.99.99 0 .55.45.99.99.99h10.18C11.5 7.92 10.44 9.75 9 11.35c-.81-.89-1.49-1.86-2.06-2.88-.16-.29-.45-.47-.78-.47-.69 0-1.13.75-.79 1.35.63 1.13 1.4 2.21 2.3 3.21L3.3 16.87c-.4.39-.4 1.03 0 1.42.39.39 1.02.39 1.42 0L9 14l2.02 2.02c.51.51 1.38.32 1.63-.35zM17.5 10c-.6 0-1.14.37-1.35.94l-3.67 9.8c-.24.61.22 1.26.87 1.26.39 0 .74-.24.88-.61l.89-2.39h4.75l.9 2.39c.14.36.49.61.88.61.65 0 1.11-.65.88-1.26l-3.67-9.8c-.22-.57-.76-.94-1.36-.94zm-1.62 7l1.62-4.33L19.12 17h-3.24z' />
        </SVG>
    ),
    expand_more: (
        <SVG>
            <path d='M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z' />
        </SVG>
    ),
    rotate: (
        <SVG>
            <path d='M11.65,4.58C11.26,4.2,10.75,4,10.23,4C9.72,4,9.21,4.2,8.82,4.59L4.59,8.82c-0.78,0.78-0.78,2.04,0,2.82l7.77,7.77 c0.39,0.39,0.9,0.59,1.41,0.59s1.02-0.2,1.41-0.59l4.24-4.24c0.78-0.78,0.78-2.04,0-2.82L11.65,4.58z M13.77,18L6,10.24L10.23,6 L18,13.76L13.77,18z M13.04,0.05C12.7,0.02,12.35,0,12,0c-0.6,0-1.2,0.05-1.77,0.14C9.82,0.2,9.66,0.7,9.95,0.99l3.2,3.16 C13.46,4.47,14,4.25,14,3.8V2.2c4.28,0.87,7.57,4.48,7.96,8.92c0.04,0.5,0.48,0.88,0.99,0.88h0c0.6,0,1.05-0.52,1-1.12 C23.42,5.12,18.81,0.55,13.04,0.05z M10,21.8c-4.28-0.87-7.57-4.48-7.96-8.92C1.99,12.38,1.56,12,1.05,12h0 c-0.6,0-1.05,0.52-1,1.12c0.53,5.76,5.14,10.34,10.91,10.83C11.3,23.98,11.65,24,12,24c0.59,0,1.16-0.05,1.72-0.13 c0.41-0.06,0.59-0.56,0.29-0.85l-3.16-3.16C10.54,19.54,10,19.76,10,20.21V21.8z' />
        </SVG>
    ),

    help: (
        <SVG>
            <path className='primary' d='M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z' />
            <path
                className='secondary'
                d='M12 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.5a1 1 0 0 1-2 0v-1.41a1 1 0 0 1 .55-.9L14 10.5C14.64 10.08 15 9.53 15 9c0-1.03-1.3-2-3-2-1.35 0-2.49.62-2.87 1.43a1 1 0 0 1-1.8-.86C8.05 6.01 9.92 5 12 5c2.7 0 5 1.72 5 4 0 1.3-.76 2.46-2.05 3.24L13 13.2V14z'
            />
        </SVG>
    ),
    dashboard: (
        <SVG>
            <path
                className='secondary'
                d='M3 11h2a1 1 0 0 1 0 2H3v-2zm3.34-6.07l1.42 1.41a1 1 0 0 1-1.42 1.42L4.93 6.34l1.41-1.41zM13 3v2a1 1 0 0 1-2 0V3h2zm6.07 3.34l-1.41 1.42a1 1 0 1 1-1.42-1.42l1.42-1.41 1.41 1.41zM21 13h-2a1 1 0 0 1 0-2h2v2z'
            />
            <path
                className='primary'
                d='M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-6.93-6h13.86a8 8 0 1 0-13.86 0z'
            />
            <path
                className='secondary'
                d='M11 14.27V9a1 1 0 0 1 2 0v5.27a2 2 0 1 1-2 0z'
            />
        </SVG>
    ),
    chevronDown: (
        <SVG>
            <path
                className='secondary'
                fillRule='evenodd'
                d='M15.3 10.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z'
            />
        </SVG>
    ),
};

export default icons;
